"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcheckmarkfilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcheckmarkfilled` : '') + (description ? ` desc-brandedcheckmarkfilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcheckmarkfilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcheckmarkfilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58 29C58 45.0136 45.0162 58.0027 29.0026 58.0027C12.9891 58.0027 0 45.0188 0 29C0 12.9813 12.9838 0.00268555 28.9974 0.00268555C45.0109 0.00268555 57.9948 12.9865 57.9948 29H58Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9989 0.00260784V58C21.5 58 13.9716 55.1059 8.50003 49.5C2.96148 43.82 0.0659991 36.3982 0.0501147 29C0.0337947 21.3989 3.05158 13.7228 8.9431 8.08623C14.7322 2.55368 21.5429 -0.096936 28.9989 0.00260784Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.3475 35.4989C26.0275 35.5756 25.9666 35.3915 25.7837 35.2074C24.2292 33.6193 21.8061 29.0241 20.0383 28.2185C16.6779 26.6919 13.6985 30.1748 15.5883 33.4582C16.5103 35.0539 22.6367 43.1552 23.8863 44.1678C25.738 45.6791 28.504 44.9963 29.9441 43.2089C32.1615 40.4624 35.2171 34.1947 36.9849 30.8499C38.3641 28.2415 39.6367 25.5565 40.932 22.9021C41.3359 22.0659 41.8693 21.245 42.2579 20.4242C42.8751 19.1123 44.6277 15.7368 44.8868 14.5861C45.8316 10.4894 40.6196 8.18796 38.3108 11.7859C37.6021 12.8983 37.0078 14.2869 36.383 15.4683C35.9943 16.2125 35.6362 17.0026 35.2476 17.7545C32.2072 23.6232 29.2431 29.5457 26.3475 35.4835V35.4989Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedcheckmarkfilled;